import { Navigate, Route, Routes } from 'react-router-dom';
import NotFound from '@rsos/components/capstone/ErrorBoundary/NotFound';
import AccessApp from '../sections/access_management/app/App';
import AlertsRoutingApp from '../sections/alerts_routing/app/App';
import CommunicationApp from '../sections/communication/app/App';
import DatasourceApp from '../sections/datasource/App';
import IntegrationApp from '../sections/integration_management/app/App';
import KeywordApp from '../sections/keyword/App';
import LandingZonesApp from '../sections/landing_zones/app/App';
import NotificationsApp from '../sections/notifications/app/App';
import PeerAgenciesApp from '../sections/peer_agencies/app/App';
import PsapApp from '../sections/psap_management/app/App';
import RespondersApp from '../sections/responders/app/App';
import SettingsApp from '../sections/settings/app/App';

// Top-level routing for the consolidated admin app. Each section's `App` is its
// own init/permission gate. react-router ranks routes by specificity, so the
// explicit section segments win over the `/admin/*` splat, which
// CommunicationApp owns (its internal router matches the `text-from-911` and
// `messaging` segments and applies the messaging redirect).
function Main() {
  return (
    <Routes>
      <Route path="/admin/settings/*" element={<SettingsApp />} />
      <Route path="/admin/notifications/*" element={<NotificationsApp />} />
      <Route path="/admin/data-source/*" element={<DatasourceApp />} />
      <Route path="/admin/keywords/*" element={<KeywordApp />} />
      <Route path="/admin/access/*" element={<AccessApp />} />
      <Route path="/admin/integrations/*" element={<IntegrationApp />} />
      <Route path="/admin/psap/*" element={<PsapApp />} />
      <Route path="/admin/alerts-routing/*" element={<AlertsRoutingApp />} />
      <Route path="/admin/responders/*" element={<RespondersApp />} />
      <Route path="/admin/landing-zones/*" element={<LandingZonesApp />} />
      <Route path="/admin/share-and-chat/*" element={<PeerAgenciesApp />} />
      <Route
        path="/admin/peer-agencies"
        element={<Navigate to="/admin/share-and-chat" replace />}
      />
      <Route path="/admin/*" element={<CommunicationApp />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Main;
